import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, BidRange, FeatureType, Grid, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { RangeComponent } from './range.component'

@Component({
    templateUrl: './ranges.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class RangesComponent extends BaseComponent {
    faSearch = faSearch
    public grid: Grid<BidRange>

    constructor() {
        super()
        this.grid = new Grid<BidRange>(this.services)
            .setupModalEditing(this.services.data.bidRanges, 'Bid Range', RangeComponent, () => new BidRange(), this, ModalSize.small)
            .filterBy(item => [item.name])
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.bidRanges.queryAll()).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.grid.items = result[0]
                },
            }),
        )
    }
    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.BidAnalyticsEdit])
    }
}
